import { render, staticRenderFns } from "./entry-description.vue?vue&type=template&id=694d2f32&"
import script from "./entry-description.vue?vue&type=script&lang=js&"
export * from "./entry-description.vue?vue&type=script&lang=js&"
import style0 from "./entry-description.vue?vue&type=style&index=0&id=694d2f32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports